import { SelectableTablePossibleCellsType } from '../../components/SelectableTable/SelectableTable.types';
import { IPageInfo } from '../../models/page.types';

export interface IRoleAndPermissionsResponse {
  list: IRoleAndPermissions[];
  totalClaimsCount: number;
  pageInfo: IPageInfo;
  roleWithPermissions: IRoleAndPermissions[];
  permissions: IRoleAndPermissions[];
  description: IRoleDetails[];
}

export interface IRoleAndPermissions {
  [key: string]: SelectableTablePossibleCellsType;
  roleId: string;
  roleName: string;
  roleDescription: string;
  claimsWithThatRoleCount: number;
  usersWithThatRoleCount: number;
  isDefault: boolean;
  isUserAssignedToRole: boolean;
}

export interface IRoleForUser {
  [key: string]: SelectableTablePossibleCellsType;
  id: string;
  roleName: string;
  roleDescription: string;
  claimsWithThatRoleCount: number;
  usersWithThatRoleCount: number;
  isDefaultRole: boolean;
  isUserAssignedToRole: boolean;
}

export interface IPermissionDetail {
  id: string;
  name: string | null;
  isActive: boolean;
}

export interface IRoleDetails {
  id: string;
  name: string;
  description: string;
  isDefault: boolean;
  permissions: IPermissionDetail[];
}

export interface IActivePermissionsDetails {
  id?: string;
  description: string;
}

export interface IRole {
  roleId: string;
  roleName: string;
  roleDescription: string;
}

export interface IRoleForEditing {
  roleId: string;
  roleName: string;
  description: string;
}

export interface IRoleDeleteResult {
  error: RolesDeleteStatus;
}

export enum RolesDeleteStatus {
  Success,
  Error,
  RoleIsDefault,
  UsersExistsInRole,
  OnlyForAdminError,
}
